module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CRQfl/tc-custom/9781913682316.jpg?1728851738792",
      "alt": "This image is the cover for the book Little Bird"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Little Bird\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Past and present traumas collide in Northern Ireland as a serial killer stalks the streets of Belfast in this gritty crime thriller.")])]), _c('p', [_vm._v(" Irish forensic psychologist Declan Wells has been off the beat since a car bomb in Belfast left him bound to a wheelchair. These days, the Troubles are supposed to be over. But with a serial killer on the loose, the city’s young women are in more danger than ever. When the killer strikes close to home, Declan is desperate to get involved in the case—but to do that, he’ll need a new partner. ")]), _vm._v(" Running away from a dead-end relationship, Welsh Detective Anna Cole is leaving Cardiff for a secondment to the Police Service of Northern Ireland. She’s hoping for a distraction from her life. What she gets is a case—and a partner—that will change it forever. As Declan and Anna try to catch a killer before another life is taken, they will both have to ask if it’s ever truly possible to leave the past behind.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sharon Dempsey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0